import React from 'react'
import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import { Loading } from '../loading/Loading'
import { Colors } from '../../constants/colors'
import { platformConfig } from '../../constants/platform'
import { quarterOfWindowWidth } from '../../constants/quarterOfWindowWidth'

const LoadingButtonContainer = styled.View`
  margin-vertical: ${atlTheme.SpacingBase}px;
  margin-horizontal: ${platformConfig.isWeb() ? quarterOfWindowWidth : atlTheme.SpacingDistribute}px;
  height: ${atlTheme.HeightButtonBase}px;
  background-color: ${atlTheme.ColorBrand1Default};
  border-radius: ${atlTheme.BorderRadiusFloatingButton}px;
  justify-content: center;
`

export const ButtonWithLoading: React.FC = () => {
  return (
    <LoadingButtonContainer>
      <Loading color={Colors.white} size={'small'} />
    </LoadingButtonContainer>
  )
}
